import { Flex, Icon, IconButton, Image, Text } from '@chakra-ui/react';
import { IconType } from '@react-icons/all-files';
import { FiEye } from '@react-icons/all-files/fi/FiEye';
import { FiRefreshCw } from '@react-icons/all-files/fi/FiRefreshCw';
import { ReactNode } from 'react';

type ViewFileButtonProps = {
  url: string | null;
};

export const ViewFileButton = ({ url }: ViewFileButtonProps) => (
  <IconButton
    aria-label="View"
    icon={<Icon as={FiEye} boxSize="15px" />}
    size="sm"
    variant="ghost"
    color="oceanBoatBlue"
    isDisabled={!url}
    onClick={() => {
      if (url) window.open(url, '_blank', 'noopener');
    }}
  />
);

type ReplaceFileButtonProps = {
  isReplacing: boolean;
  onReplace: () => void;
};

export const ReplaceFileButton = ({ isReplacing, onReplace }: ReplaceFileButtonProps) => (
  <IconButton
    aria-label="Replace"
    icon={<Icon as={FiRefreshCw} boxSize="15px" />}
    size="sm"
    variant="ghost"
    color="grayMedium"
    isLoading={isReplacing}
    onClick={onReplace}
  />
);

type DocumentsPanelRowProps = {
  thumbnailUrl?: string | null;
  fallbackIcon: IconType;
  name: string;
  actions: ReactNode;
};

const DocumentsPanelRow = ({
  thumbnailUrl,
  fallbackIcon,
  name,
  actions,
}: DocumentsPanelRowProps) => (
  <Flex align="center" gap="10px" px="10px" py="8px" bg="white" borderRadius="11px">
    <Flex
      flex="none"
      w="36px"
      h="36px"
      borderRadius="9px"
      align="center"
      justify="center"
      bg="grayLightest"
      color="grayMedium"
      overflow="hidden"
    >
      {thumbnailUrl ? (
        <Image
          src={thumbnailUrl}
          alt=""
          boxSize="36px"
          objectFit="cover"
          fallback={<Icon as={fallbackIcon} boxSize="18px" />}
        />
      ) : (
        <Icon as={fallbackIcon} boxSize="18px" />
      )}
    </Flex>
    <Text flex="1" minW={0} fontSize="13px" fontWeight="600" color="leaseEndBlue" noOfLines={1}>
      {name}
    </Text>
    {actions}
  </Flex>
);

export default DocumentsPanelRow;
